import { createScenarioSnapshot, scenarioSignature } from '../../domain/comparison/scenarioSnapshot';
import React, { createContext, useContext, useState, useEffect } from "react";
import { Simulador } from "./../../utils/simulador"; // Certifique-se de que o caminho está correto

// Criação do Contexto
const SimuladorContext = createContext();

const normalizeSystemMode = (mode) => (mode === "cria" ? "cria" : "ciclo_completo");

const getInitialSystemMode = () => normalizeSystemMode(localStorage.getItem("mybeef_system_mode"));

const cloneSimulatorWithMode = (current, mode) => {
  if (!current) return current;

  const next = Object.assign(Object.create(Object.getPrototypeOf(current)), current);
  if (typeof next.set_system_mode === "function") {
    next.set_system_mode(mode);
  } else {
    next.systemMode = normalizeSystemMode(mode);
    next.idade_venda = next.systemMode === "cria" ? 1 : next.idade_venda;
  }
  return next;
};

// Criar o Provider
export const SimuladorProvider = ({ children }) => {
  const [systemMode, setSystemModeState] = useState(getInitialSystemMode);
  const [goalSession, setGoalSession] = useState(null);
  const [investmentSession, setInvestmentSession] = useState(null);
  const [criaCalibrationReference, setCriaCalibrationReference] = useState(null);

  const [simulador, setSimulador] = useState(() => new Simulador({
    systemMode: getInitialSystemMode()
  }));
  const [simulador_2, setSimulador2] = useState(() => new Simulador({
    systemMode: getInitialSystemMode(),
    desmame: 70,
    idade_venda: getInitialSystemMode() === "cria" ? 1 : 2,
    idade_entoure: 2
  }));

  const [dadosUsuario, setDadosUsuario] = useState({
    nome: '',
    municipio: '',
    uf: '',
    pais: 'Brasil',
    unidade: '',
    email: '',
    telefone: '',
    tamanho_rebanho: undefined,
    tipoUsuario: '' // 'tecnico' ou 'pecuarista'
  });

  useEffect(() => {
    const clear = () => {
      setGoalSession(null); setInvestmentSession(null); setDadosUsuario({});
      setCriaCalibrationReference(null);
      setSimulador(new Simulador({ systemMode: getInitialSystemMode() }));
      setSimulador2(new Simulador({ systemMode: getInitialSystemMode() }));
    };
    window.addEventListener('mybeef-session-cleared', clear);
    return () => window.removeEventListener('mybeef-session-cleared', clear);
  }, []);
  const realSignature = scenarioSignature(createScenarioSnapshot(simulador));
  const identity = dadosUsuario.email || dadosUsuario.user?.email || '';
  useEffect(() => { setGoalSession(null); setInvestmentSession(null); }, [realSignature, identity]);

  // Função para alterar o modo de simulação de forma limpa e persistente
  const setSystemMode = (mode) => {
    const nextMode = normalizeSystemMode(mode);
    setSystemModeState(nextMode);
    localStorage.setItem("mybeef_system_mode", nextMode);
    setSimulador((current) => cloneSimulatorWithMode(current, nextMode));
    setSimulador2((current) => cloneSimulatorWithMode(current, nextMode));
  };

  return (
    <SimuladorContext.Provider
      value={{
        goalSession, setGoalSession, investmentSession, setInvestmentSession,
        systemMode,
        setSystemMode,
        criaCalibrationReference,
        setCriaCalibrationReference,
        simulador,
        setSimulador,
        simulador_2,
        setSimulador2,
        dadosUsuario,     // Fornece o estado com os dados
        setDadosUsuario   // Fornece a função para atualizar os dados
      }}
    >
      {children}
    </SimuladorContext.Provider>
  );
};

// Hook para facilitar o acesso ao contexto
export const useSimulador = () => {
  const context = useContext(SimuladorContext);
  if (!context) {
    throw new Error("useSimulador deve ser usado dentro de um SimuladorProvider");
  }
  return context;
};
